import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Button } from '@mui/material';
import './initialLoginPage.css';
import Header from '../../layouts/header';
import { useNavigate } from 'react-router-dom';
import { languageCodeMapper } from '../space/translationCodeMapper';
import Labels from '../../components/translations/translation.json'
import settingMobileIcon from '../../Asset/Images/settingMobileIcon.png';
import Footer from '../../layouts/footer/footer';
import Loader from '../../layouts/loader/index';
import {  getNMBSLoadingSelection,getLanguagePreference , clearNMBSLoadingSelection} from '../storage/selectionStorage';

function InitialLoginPage(props) {

  var userLang = navigator.language || navigator.userLanguage; 
  console.log("userLang from browser in initial page",userLang);
  // const isPrivate = localStorage.getItem("isPrivate");
  const [isPrivate, setIsPrivate] = useState(null); // Initially null, to show loading fallback if needed

  const langCodebrowser = languageCodeMapper(userLang);

  const [langCode, setlangCode] = useState(langCodebrowser);
  const [isLoading,setIsLoading] = useState(false);

  const [mobileLoginPage, setMobileLoginPage] = useState(window.innerWidth <= 500);
  console.log("window.innerWidth  condition :",mobileLoginPage);

useEffect(() => {
  const fetchIsPrivate = async () => {
    const value = await Promise.resolve(localStorage.getItem('isPrivate'));
    console.log("Fetched isPrivate from localStorage:", value); // Log the actual value
    setIsPrivate(value);
  };

  fetchIsPrivate();
}, []);
  

  useEffect(() => {
    console.log("isPrivate value is",isPrivate);
    if (isPrivate !== null) {
      document.title = isPrivate === "true" ? "FixMyOffice" : "FixMyStation";
    }
  }, [isPrivate]);
  

  const handleWindowSizeChangeLoginPage = () => {
    if(window.innerWidth <= 500){
      setMobileLoginPage(true);
    }else{
      setMobileLoginPage(false);
    }
  }



  const navigate = useNavigate();


  const handleEvent = () => {
    navigate("/",{state:{thankyou:true}})
  };

  useEffect(()=>{
    const storedLoginSelection = getNMBSLoadingSelection();
    console.log("storedLoginSelection in initialLoginPage useEffect",storedLoginSelection);
    if(storedLoginSelection){
      setIsLoading(true);
      clearNMBSLoadingSelection();
    }
  })

  useEffect(() => {
    window.addEventListener("popstate", handleEvent);
    return () => window.removeEventListener("popstate", handleEvent);
  });

  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChangeLoginPage);
      return () => {
      window.removeEventListener('resize', handleWindowSizeChangeLoginPage);
      }
  }, []);

  useEffect(() => {
    console.log("useEffect of IntitialLogin");
    const getLangCode = async () => {
      const languagePref = await getLanguagePreference()  
      console.log("languagePref in handleNMBSEmployeeLogin",languagePref);
      localStorage.setItem("languagePref",languagePref ? languagePref : langCodebrowser);
    }
    getLangCode()
  }, [])


  console.log("langCode in initialLogin from browser ", langCode);

  const handledropdown = (e) => {
		setlangCode(e.target.value);
    localStorage.setItem("languagePref",e.target.value);
  }

  const loginTypeNMBSEMPLOYEE = () => {
      console.log("NMBS EMPLOYEE")
      props.loginTypeCallback("NMBS_EMPLOYEE");
      localStorage.removeItem("Visitor_FMO");
  }

  const loginTypeVISITOR = () => {
      console.log("VISITOR")
      localStorage.removeItem("languageCode");
      props.loginTypeCallback("VISITOR");

      if(isPrivate){
        // Visitor flow in FMO.
        console.log("Visitor flow in FMO");
        localStorage.setItem("Visitor_FMO",true);
      }else{
        localStorage.removeItem("Visitor_FMO");

      }
  }

  console.log("langCode in initialLogin of handleDropdown ", langCode); 

  return (
    isLoading ? <Loader /> : (
      <div>
        <Header 
          langCode={langCode}
          handledropdown={handledropdown} 
          isPrivate={isPrivate == "true"}
        />
        <Container fluid style={{ height: '100%', backgroundColor: '#F0F5FA' }} className='container-loginPage-main'>
          <Row className="row">
            <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}><div /></Col>
  
            <Col xl={6} lg={6} md={8} sm={10} xs={12} xxs={12} className="subMain-container-loginPage">
              {mobileLoginPage &&
                <Container fluid className="container-setting-logo-loginPage">
                  <div>
                    <img
                      className="settingIcon-img-loginPage"
                      width={50}
                      height={50}
                      src={settingMobileIcon}
                      alt="Setting Logo"
                    />
                  </div>
                </Container>
              }
  
              <Container fluid className='loginPageTitle-container'>
                <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
                  <span className='loginPage-title'>{isPrivate == "true" ? Labels[langCode].FIXMYOFFICE_LOGIN_PAGE: Labels[langCode].FIXMYSTATION_LOGIN_PAGE}</span>
                </Col>
              </Container>
  
              <Container fluid className='loginPageText-container'>
                <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12} className='col-logintext'>
                  <span className='loginPageText-span'>{Labels[langCode].LOGIN_PAGE_TEXT_CONTENT}</span>
                </Col>
              </Container>
  
              <Container fluid className="loginPagebuttons-container">
                <div className="div-btn-loginPage">
                  {
                    isPrivate == "true" ? (
                      // 🔁 isPrivate = true: Show SNCB Employee first
                      <>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12} className="col-btn-nmbsEmp">
                          <div className="div-nmbsemp-btn">
                            <Button
                              type="button"
                              className="btn-visitorPage btn-secondary"
                              data-disabled="false"
                              onClick={loginTypeNMBSEMPLOYEE}
                            >
                              {Labels[langCode].LOGIN_PAGE_NMBSEMP_BTN}
                            </Button>
                          </div>
                        </Col>
  
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12} className="col-btn-visitor">
                          <div className="div-visitor-btn">
                            <Button
                              type="button"
                              className="btn-loginPage btn-primary"

                              data-disabled="false"
                              onClick={loginTypeVISITOR}
                            >
                              {Labels[langCode].LOGIN_PAGE_VISITOR_BTN}
                            </Button>
                          </div>
                        </Col>
                      </>
                    ) : (
                      // 🔁 isPrivate = false: Show Visitor first
                      <>
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12} className="col-btn-visitor">
                          <div className="div-visitor-btn">
                            <Button
                              type="button"
                              className="btn-visitorPage btn-primary"
                              data-disabled="false"
                              onClick={loginTypeVISITOR}
                            >
                              {Labels[langCode].LOGIN_PAGE_VISITOR_BTN}
                            </Button>
                          </div>
                        </Col>
  
                        <Col xl={6} lg={6} md={6} sm={6} xs={12} xxs={12} className="col-btn-nmbsEmp">
                          <div className="div-nmbsemp-btn">
                            <Button
                              type="button"
                              className="btn-loginPage btn-secondary"
                              data-disabled="false"
                              onClick={loginTypeNMBSEMPLOYEE}
                            >
                              {Labels[langCode].LOGIN_PAGE_NMBSEMP_BTN}
                            </Button>
                          </div>
                        </Col>
                      </>
                    )
                  }
                </div>
              </Container>
            </Col>
  
            <Col xl={3} lg={3} md={2} sm={1} xs={0} xxs={0}><div /></Col>
          </Row>
  
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12} xxs={12}>
              <Container className='container-footer'></Container>
            </Col>
          </Row>
  
          <Footer />
        </Container>
      </div>
    )
  );
  
  
  
}

export default InitialLoginPage;
